export const CompanyLabels = {
  CONTACT_SCHEDULE_URL: 'Contact Schedule',
  JOB_TYPE_INFO_URL: 'Company Job Type Info',
  SCHEDULE_URL: 'Availability Schedule',
  APPLICANT_WEBSITE: 'Company Applicant Website',
  WEBSITE: 'Company Website'
} as const;

export const ServiceTitanAvailability = {
  USE_ADAPTIVE_AVAILABILITY: 'Use Service Titan - Get Adaptive Availability',
  USE_GET_AVAILABILITY: 'Use Service Titan - Get Availability'
} as const;
